<template>
  <img
    src="@/assets/images/experian.png"
    :width="width"
    style="object-fit: contain"
  />
</template>

<script>
export default {
  props: {
    width: {
      type: Number,
      default: 100,
    },
  },
};
</script>

<style></style>
